import React from "react";
import TeamImage from '../../resources/logo.jpg';
import navigateTo from '../functions/navigateTo'

const Team = () => {
    return (
    <div className="page__section" id="team">
        <p className="title">Chi Siamo</p>
        <hr></hr>
        <div className='team__content'>
        <div className='team__text'>
            <p className="team__text__cell team__name">bE-More</p>
            <p className="team__text__cell team__slogan">With Us, bE-More.</p>
            <p className="team__text__cell">Studenti della classe 4Ht-i dell'<a href='https://www.isarchimede.edu.it/' target="_blank">I.S. Archimede</a>, <br></br>vedi <a onClick={ () => navigateTo('contacts') }>Contattaci.</a></p>
        </div>
        <img className='team__image' src={TeamImage}></img>
        </div>
    </div>
    );
};


export default Team;